import React from 'react'
import { EnlaceBase, useDiseñoConfig } from './ComponenteBase'

const DiseñoLista = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Obtener configuración del diseño
  const config = useDiseñoConfig('lista', configuracion)

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-1">
        {enlaces.map((enlace, index) => (
          <EnlaceBase
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            configuracion={{
              ...config,
              // Ajustes específicos para miniatura
              tamañoIcono: 'pequeño',
              tema: 'lista'
            }}
            className="enlace-miniatura"
          />
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-1">
      {enlaces.map((enlace, index) => (
        <EnlaceBase
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          configuracion={{
            ...config,
            numeracion: config.numeracion ? index + 1 : false
          }}
          className="group"
        />
      ))}
    </div>
  )
}

export default DiseñoLista 